module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0yMS44ODc1IDQuODM3NUwxOS42NjI1IDIuNjI1TDcuMzAwMDUgMTVMMTkuNjc1IDI3LjM3NUwyMS44ODc1IDI1LjE2MjVMMTEuNzI1IDE1TDIxLjg4NzUgNC44Mzc1WiIgZmlsbD0iIzY4Njg2OCIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/back.svg
// module id = dqYA
// module chunks = 0